import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import AppPaths from '../../AppPaths';
import { ReactComponent as EmptyCartIllustration } from '../../assets/images/illustrations/empty_cart.svg';
import HardwareFirstCartHeader from './HardwareFirstCartHeader';
import styles from './HardwareFirstEmptyCart.module.scss';

/** The arm's empty cart: the same tinted page, with the only route out being back to the plp. */
export default function HardwareFirstEmptyCart() {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <div className={styles.page}>
      <HardwareFirstCartHeader />
      <div className={styles.content}>
        <div className={styles.copy}>
          <h2 className={styles.title}>{t('hardware_first_cart_empty_title')}</h2>
          <p className={styles.subtitle}>{t('dont_worry_weve_got_just_the_thing_to_get_tails_wagging')}</p>
        </div>
        <EmptyCartIllustration className={styles.illustration} />
        <button className={styles.shopButton} onClick={() => history.push(AppPaths.Shop)} type="button">
          {t('shop_fi')}
        </button>
      </div>
    </div>
  );
}
